<template>
  <section>
    <div class="container">
      <div v-if="fill_info == ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">ÚNKP-19 Ösztöndíjszerződés adattábla</div>
        </div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="nev" label="Viselt neve" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ]+" v-model="form.nev" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="szuletesi_nev" label="Születési neve" name="szuletesi_nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ]+" v-model="form.szuletesi_nev" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="szulhely" label="Születési hely" regexp_filter="[0-9a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+" name="szulhely" v-model="form.szulhely" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="szulido" label="Születési dátum" name="szulido" v-model="form.szulido" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="anyja_neve" label="Anyja neve" name="anyja_neve" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ]+" v-model="form.anyja_neve" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="adoazonosito_jel" label="Adóazonosító jel" regexp_filter="[0-9]{10}" name="adoazonosito_jel" v-model="form.adoazonosito_jel" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="lakcim" label="Állandó lakcím <span style='font-size: 10px; display: block; font-weight: 400'>(irányítószám, település, utca, házszám)</span>" name="lakcim" v-model="form.lakcim" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="levcim" label="Levelezési cím <span style='font-size: 10px; display: block; font-weight: 400'>(irányítószám, település, utca, házszám)</span>" name="levcim" v-model="form.levcim" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="taj_szam" label="TAJ szám" regexp_filter="[0-9]+" name="taj_szam" v-model="form.taj_szam" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="bank_nev" label="Számlavezető bank neve" name="bank_nev" v-model="form.bank_nev" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="bankszamlaszam" label="Bankszámlaszám" regexp_filter="[0-9]+" name="bankszamlaszam" v-model="form.bankszamlaszam" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="allampolgarsag" label="Állampolgárság" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+" name="allampolgarsag" v-model="form.allampolgarsag" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="email" label="E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>" name="email" v-model="form.email" :errors="errors"/>
        </div>
        <div class="col-sm-6">

        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="mobilszam" label="Mobilszám" mask="+99 99 / 999 9999" regexp_filter="[0-9]+" name="mobilszam" v-model="form.mobilszam" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="egyeb_telefonszam" label="Egyéb telefonszám" regexp_filter="[0-9]+" name="egyeb_telefonszam" v-model="form.egyeb_telefonszam" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="palyazati_azonosito" label="Pályázati azonosító <span style='font-size: 10px; display: block; font-weight: 400'>(Az egyedi azonosító számot a pályázat befogadásáról szóló értesítő e-mailben kapta meg)</span>" name="palyazati_azonosito" v-model="form.palyazati_azonosito" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="kutatas_cime" label="A Pályázat keretében támogatott kutatás címe <span style='font-size: 10px; display: block; font-weight: 400'>(pályázat beadásakor elfogadott cím)</span>" name="kutatas_cime" v-model="form.kutatas_cime" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <comboboxV2 @onChange="tudomanyTeruletValt" label="Tudományterület <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>" id="tudomanyterulet" name="tudomanyterulet" :options="tudomanyteruletek" v-model="form.tudomanyterulet" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <comboboxV2 label="Tudomány- ill., művészeti ág <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>" id="tudomanyag" name="tudomanyag" :options="tudomanyagak" v-model="form.tudomanyag" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <comboboxV2 label="Képzési terület kódja <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>" id="kepzesi_terulet" name="kepzesi_terulet" :options="kepzesi_teruletek" v-model="form.kepzesi_terulet" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" id="hallgatoi_kepzes" label="Képzés neve <span style='font-size: 10px; display: block; font-weight: 400'>(Neptun alapján Alap, Mester, Tehetséggel fel kategóriáknál)</span>" name="hallgatoi_kepzes" v-model="form.hallgatoi_kepzes" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <comboboxV2 @onChange="jogviszonyIdotartamValt" label="Az ösztöndíjas jogviszony időtartama" id="jogviszony_idotartam" name="jogviszony_idotartam" :options="jogviszony_opt" v-model="form.jogviszony_idotartam" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox :disabled="true" id="jogviszony_befejezes_idopont" label="Az ösztöndíjas jogviszony befejezésének időpontja" name="jogviszony_befejezes_idopont" v-model="form.jogviszony_befejezes_idopont" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox :disabled="disable_fields" @input="form.neptunkod = form.neptunkod.toUpperCase()" id="neptunkod" regexp_filter="[0-9A-Za-z]{6}" label="Neptun kód" name="neptunkod" v-model="form.neptunkod" :errors="errors"/>
        </div>
        <div class="col-xs-12">
          <div class="info-box warning">
            Kérem véglegesítés előtt <span class="highlight">ellenőrizze</span> a NEPTUN-ból beemelt adatait! Ha hiányosságot, vagy eltérést tapasztal, akkor azt legyen kedves <span class="highlight">először a NEPTUN-ban javítani</span> és utána újra kitölteni, menteni és véglegesíteni az űrlapot. <span class="highlight">Az űrlap alapján elkészült Ösztöndíjszerződésen a későbbiekben nem áll módunkban módosítani!</span>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="info-box download">
            <a target="_blank" href="assets/urlap_kitoltesek/UNKP_2019_2020_tanev_osztondijszerzodes_minta.pdf" title="ÚNKP-19 Ösztöndíjszerződés minta">
              <span class="highlight">ÚNKP-19 Ösztöndíjszerződés minta</span> megtekintése
            </a>
          </div>
        </div>
        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(1)" :disabled="!save_enabled" type="button" name="kuld" class="button">Mentés</button>
            <button v-on:click="save(2)" :disabled="!save_enabled" type="button" name="kuld" class="button">Véglegesít</button>
          </div>
        </div>
      </div>
      <div v-if="fill_info != ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">ÚNKP-19 Ösztöndíjszerződés adattábla</div>
          <div v-html="fill_info"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';

export default {
  components: {
  },
  data: function() {
    return {
      save_enabled: true,
      errors: [],
      fill_info: '',
      jogviszony_opt: [
        {
          value: 0,
          label: '- válasszon -',
          idopont: ''
        },
        {
          value: 5,
          label: '5 Hónap',
          idopont: '2020. január 31.'
        },
        {
          value: 10,
          label: '10 hónap',
          idopont: '2020. június 30.'
        }
      ],
      tudomanyteruletek: [{value:'Agrártudományok (I)',label:'Agrártudományok (I)',agak:[{value:'Állatorvosi tudományok (1)',label:'Állatorvosi tudományok (1)'},{value:'Állattenyésztési tudományok (2)',label:'Állattenyésztési tudományok (2)'},{value:'Élelmiszertudományok (3)',label:'Élelmiszertudományok (3)'},{value:'Erdészeti és vadgazdálkodási tudományok (4)',label:'Erdészeti és vadgazdálkodási tudományok (4)'},{value:'Növénytermesztési és kertészeti tudományok (5)',label:'Növénytermesztési és kertészeti tudományok (5)'}]},{value:'Bölcsészettudományok (II)',label:'Bölcsészettudományok (II)',agak:[{value:'Filozófiai tudományok (1)',label:'Filozófiai tudományok (1)'},{value:'Irodalom- és kultúratudományok (2)',label:'Irodalom- és kultúratudományok (2)'},{value:'Művészettörténeti és művelődéstörténeti tudományok (3)',label:'Művészettörténeti és művelődéstörténeti tudományok (3)'},{value:'Művészettudomány (4)',label:'Művészettudomány (4)'},{value:'Néprajz- és kulturális antropológia (5)',label:'Néprajz- és kulturális antropológia (5)'},{value:'Neveléstudományok (6)',label:'Neveléstudományok (6)'},{value:'Nyelvtudományok (7)',label:'Nyelvtudományok (7)'},{value:'Pszichológiai tudományok (8)',label:'Pszichológiai tudományok (8)'},{value:'Történelemtudományok (9)',label:'Történelemtudományok (9)'},{value:'Vallástudományok (10)',label:'Vallástudományok (10)'}]},{value:'Hittudományok (III)',label:'Hittudományok (III)',agak:[{value:'Hittudományok (1)',label:'Hittudományok (1)'}]},{value:'Műszaki tudományok (IV)',label:'Műszaki tudományok (IV)',agak:[{value:'Agrárműszaki tudományok (1)',label:'Agrárműszaki tudományok (1)'},{value:'Anyagtudományok és technológiák (2)',label:'Anyagtudományok és technológiák (2)'},{value:'Bio-, környezet- és vegyészmérnöki tudományok (3)',label:'Bio-, környezet- és vegyészmérnöki tudományok (3)'},{value:'Építészmérnöki tudományok (4)',label:'Építészmérnöki tudományok (4)'},{value:'Építőmérnöki tudományok (5)',label:'Építőmérnöki tudományok (5)'},{value:'Gépészeti tudományok (6)',label:'Gépészeti tudományok (6)'},{value:'Informatikai tudományok (7)',label:'Informatikai tudományok (7)'},{value:'Katonai műszaki tudományok (8)',label:'Katonai műszaki tudományok (8)'},{value:'Közlekedés- és járműtudományok (9)',label:'Közlekedés- és járműtudományok (9)'},{value:'Villamosmérnöki tudományok (10)',label:'Villamosmérnöki tudományok (10)'}]},{value:'Művészetek (V)',label:'Művészetek (V)',agak:[{value:'Építőművészet (1)',label:'Építőművészet (1)'},{value:'Film- és videoművészet (2)',label:'Film- és videoművészet (2)'},{value:'Iparművészet (3)',label:'Iparművészet (3)'},{value:'Képzőművészet (4)',label:'Képzőművészet (4)'},{value:'Multimédia-művészet (5)',label:'Multimédia-művészet (5)'},{value:'Színházművészet (6)',label:'Színházművészet (6)'},{value:'Tánc- és mozdulatművészet (7)',label:'Tánc- és mozdulatművészet (7)'},{value:'Zeneművészet (8)',label:'Zeneművészet (8)'}]},{value:'Orvostudományok (VI)',label:'Orvostudományok (VI)',agak:[{value:'Egészségtudományok (1)',label:'Egészségtudományok (1)'},{value:'Elméleti orvostudományok (2)',label:'Elméleti orvostudományok (2)'},{value:'Gyógyszerészeti tudományok (3)',label:'Gyógyszerészeti tudományok (3)'},{value:'Klinikai orvostudományok (4)',label:'Klinikai orvostudományok (4)'},{value:'Sporttudományok (5)',label:'Sporttudományok (5)'}]},{value:'Társadalomtudományok (VII)',label:'Társadalomtudományok (VII)',agak:[{value:'Állam- és jogtudományok (1)',label:'Állam- és jogtudományok (1)'},{value:'Gazdálkodás- és szervezéstudományok (2)',label:'Gazdálkodás- és szervezéstudományok (2)'},{value:'Hadtudományok (3)',label:'Hadtudományok (3)'},{value:'Közgazdaságtudományok (4)',label:'Közgazdaságtudományok (4)'},{value:'Közigazgatás-tudományok (5)',label:'Közigazgatás-tudományok (5)'},{value:'Média-és kommunikációs tudományok (6)',label:'Média-és kommunikációs tudományok (6)'},{value:'Politikatudományok (7)',label:'Politikatudományok (7)'},{value:'Regionális tudományok (8)',label:'Regionális tudományok (8)'},{value:'Rendészettudomány (9)',label:'Rendészettudomány (9)'},{value:'Szociológiai tudományok (10)',label:'Szociológiai tudományok (10)'}]},{value:'Természettudományok (VIII)',label:'Természettudományok (VIII)',agak:[{value:'Biológiai tudományok (1)',label:'Biológiai tudományok (1)'},{value:'Fizikai tudományok (2)',label:'Fizikai tudományok (2)'},{value:'Földtudományok (3)',label:'Földtudományok (3)'},{value:'Kémiai tudományok (4)',label:'Kémiai tudományok (4)'},{value:'Környezettudományok (5)',label:'Környezettudományok (5)'},{value:'Matematika- és számítástudományok (6)',label:'Matematika- és számítástudományok (6)'}]}],
      tudomanyagak: [],
      kepzesi_teruletek: [{value:'0',label:'- válasszon -'},{value:'Agrár (1)',label:'Agrár (1)'},{value:'Államtudományi (2)',label:'Államtudományi (2)'},{value:'Bölcsészettudomány (3)',label:'Bölcsészettudomány (3)'},{value:'Gazdaságtudományok (4)',label:'Gazdaságtudományok (4)'},{value:'Informatika (5)',label:'Informatika (5)'},{value:'Jogi (6)',label:'Jogi (6)'},{value:'Műszaki (7)',label:'Műszaki (7)'},{value:'Művészet (8)',label:'Művészet (8)'},{value:'Művészetközvetítés (9)',label:'Művészetközvetítés (9)'},{value:'Orvos- és egészségtudomány (10)',label:'Orvos- és egészségtudomány (10)'},{value:'Pedagógusképzés (11)',label:'Pedagógusképzés (11)'},{value:'Sporttudomány (12)',label:'Sporttudomány (12)'},{value:'Társadalomtudomány (13)',label:'Társadalomtudomány (13)'},{value:'Természettudomány (14)',label:'Természettudomány (14)'}],
      disable_fields: false,
      form: {
        nev: '',
        szuletesi_nev: '',
        szulhely: '',
        szulido: '',
        anyja_neve: '',
        lakcim: '',
        adoazonosito_jel: '',
        taj_szam: '',
        levcim: '',
        bank_nev: '',
        bankszamlaszam: '',
        allampolgarsag: '',
        email: '',
        palyazati_azonosito: '',
        kutatas_cime: '',
        hallgatoi_kepzes: '',
        kepzesi_terulet: '',
        jogviszony_idotartam: '',
        jogviszony_befejezes_idopont: '',
        mobilszam: '',
        egyeb_telefonszam: '',
        neptunkod: '',
        tudomanyterulet: '',
        tudomanyag: '',
      }
    }
  },

  computed: {
  },

  watch: {
  },

  mounted: function() {
    var _this = this;

    this.form.jogviszony_idotartam = this.jogviszony_opt[0].value;
    this.form.tudomanyterulet = this.tudomanyteruletek[0].value;
    this.form.tudomanyag = this.tudomanyteruletek[0].agak[0].value;
    this.tudomanyagak = this.tudomanyteruletek[0].agak;
    this.form.kepzesi_terulet = this.kepzesi_teruletek[0].value;

    this.$root.ajax('form/osztondijszerzodes_ell', {
      success: function(response) {
        if (response.error != false) {
          _this.fill_info = response.error;
          return;
        }

        if (response.form != undefined) {
          _this.form = response.form;

          _this.tudomanyteruletek.unshift({
            value: 0,
            label: '- válasszon -',
            agak: []
          });

          _this.tudomanyteruletek.map(function(tudomanyterulet) {
            tudomanyterulet.agak.unshift({
              value: 0,
              label: '- válasszon -'
            });
          });

          if (_this.form.adoazonosito_jel == 0)
            _this.form.adoazonosito_jel = '';

          if (_this.form.tudomanyterulet == '')
            _this.form.tudomanyterulet = _this.tudomanyteruletek[0].value;

          if (_this.form.tudomanyag == '')
            _this.form.tudomanyag = _this.tudomanyteruletek[0].agak[0].value;

          if (_this.form.kepzesi_terulet == '')
            _this.form.kepzesi_terulet = _this.kepzesi_teruletek[0].value;

          if (_this.form.jogviszony_idotartam == 0)
            _this.form.jogviszony_idotartam = _this.jogviszony_opt[0].value;

          _this.tudomanyteruletek.map(function(tudomanyterulet) {
            if (tudomanyterulet.value == _this.form.tudomanyterulet) {
              _this.tudomanyagak = tudomanyterulet.agak;
            }
          });

          _this.disable_fields = response.disable_fields;
        }
      }
    });
  },

  methods: {
    jogviszonyIdotartamValt: function() {
      var _this = this;

      this.jogviszony_opt.map(function(item) {
        if (parseInt(item.value) == parseInt(_this.form.jogviszony_idotartam))
          _this.form.jogviszony_befejezes_idopont = item.idopont;
      });
    },

    tudomanyTeruletValt: function() {
      var _this = this;

      this.tudomanyteruletek.map(function(tudomanyterulet) {
        if (tudomanyterulet.value == _this.form.tudomanyterulet) {
          _this.tudomanyagak = tudomanyterulet.agak;
          _this.form.tudomanyag = tudomanyterulet.agak[0].value;
        }
      });
    },

    save: function(veglegesit) {
      var _this = this;

      this.errors = [];

      this.$root.ajax('form/osztondijszerzodes_mentes', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          veglegesit: veglegesit
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = veglegesit == 1 ? 'Ön elmentette az űrlap kitöltését. Befogadáshoz Önnek véglegesítenie kell a kitöltését. Az űrlap megtekintéséhez kattintson az alábbi <a href="javascript:void(0)" onclick="location.reload()">linkre.</a>' : 'Köszönjük, Ön sikeresen véglegesítette az űrlap kitöltését. Az alábbi <a target="_blank" href="assets/urlap_kitoltesek/'+response.filename+'">linkről</a> letöltheti kitöltését Pdf formátumban.';
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// osztondijszerzodes.vue?2d31cfa8